
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 md:gap-12 mb-8 sm:mb-10 md:mb-12">
          {/* Logo & Description */}
          <div className="sm:col-span-2 lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/9acf540dec95fde23784f4db934ca461/cfecc50567285b9240dacf462e199b6e.png"
              alt="우미린 로고"
              className="h-10 sm:h-12 mb-4 sm:mb-6"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              공간의 가치로 공감을 채우는<br />
              프리미엄 주거 브랜드<br />
              우미린 에듀하이
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 uppercase tracking-wide">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('awards')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer"
                >
                  브랜드 수상
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('location')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer"
                >
                  입지 프리미엄
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('floorplan')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer"
                >
                  평면 정보
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('amenities')}
                  className="text-gray-400 hover:text-amber-400 transition-colors text-sm cursor-pointer"
                >
                  커뮤니티 시설
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-base sm:text-lg font-bold mb-3 sm:mb-4 uppercase tracking-wide">
              Contact
            </h3>
            <ul className="space-y-3">
              <li>
                <p className="text-xs text-gray-500 mb-1">전화</p>
                <p className="text-gray-300 text-sm">1688-1502</p>
              </li>
              <li>
                <p className="text-xs text-gray-500 mb-1">이메일</p>
                <p className="text-gray-300 text-sm">kimmeru05@naver.com</p>
              </li>
              <li>
                <p className="text-xs text-gray-500 mb-1">주소</p>
                <p className="text-gray-300 text-sm">
                  경기도 화성시 남양읍 남양리 2198번지 일원
                </p>
              </li>
            </ul>
          </div>

          {/* Image */}
          <div className="hidden lg:block rounded-2xl overflow-hidden shadow-xl">
            <img
              src="https://static.readdy.ai/image/9acf540dec95fde23784f4db934ca461/cfecc50567285b9240dacf462e199b6e.png"
              alt="단지 전경"
              className="w-full h-64 object-cover"
            />
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-6 sm:pt-8 border-t border-gray-700">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs sm:text-sm text-gray-500 text-center sm:text-left">
              © 2025 우미린 에듀하이. All rights reserved.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
              <a
                href="#"
                className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                개인정보처리방침
              </a>
              <a
                href="#"
                className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                이용약관
              </a>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs sm:text-sm text-gray-400 hover:text-white transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
